"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateWave = exports.updateSurveySettings = exports.updateSurvey = exports.updateQuestSettings = exports.updateQuest = exports.updateQueryWithoutSave = exports.updateQuery = exports.unscheduleMessage = exports.unarchiveSurvey = exports.unarchiveQuest = exports.toggleCollapsedDesignAssignment = exports.toggleCollapsedDeployAssignment = exports.toggleArchivedSurveys = exports.toggleArchivedAssignments = exports.setWaveOpenStatusAndSave = exports.setWaveOpenStatus = exports.setVizData = exports.setVisibleDeploymentIds = exports.setSelectedDeploymentIds = exports.setQueryTagFilter = exports.setQueryList = exports.setProjectList = exports.setProjectFlows = exports.setOrganizationList = exports.setExpandedAllDesignAssignments = exports.setExpandedAllDeployAssignments = exports.setDevTags = exports.setCurrentSurveyListHandle = exports.setCurrentSurveyId = exports.setCurrentSurveyHandles = exports.setCurrentSurveyHandle = exports.setCurrentQuerySettings = exports.setCurrentQueryId = exports.setCurrentProjectId = exports.setCurrentDeploymentIds = exports.setCurrentDeploymentId = exports.setCurrentAssignmentIdOnly = exports.setCurrentAssignmentId = exports.resetState = exports.reorderDeploymentsAndSave = exports.reorderAssignmentsAndSave = exports.removeWave = exports.reloadCurrentProject = exports.moveSurveyAndSave = exports.moveSurvey = exports.loadProjectList = exports.loadProject = exports.loadDevTags = exports.initialState = exports.deleteSurvey = exports.deleteQuest = exports.deleteMessage = exports.deleteFlow = exports.deleteCurrentQueryWithoutSave = exports.deleteCurrentQuery = exports["default"] = exports.createWave = exports.createSurvey = exports.createQuest = exports.createFlow = exports.clearVisibleDeploymentIds = exports.changeDesignFilter = exports.changeDeployFilter = exports.archiveSurvey = exports.archiveQuest = exports.addNewQueryWithoutSave = exports.addNewQuery = void 0;
var _react = _interopRequireDefault(require("react"));
var _reduxActions = require("redux-actions");
var _cccisdApollo = require("cccisd-apollo");
var _projectListQuery = _interopRequireDefault(require("../queries/projectListQuery.graphql"));
var _designTabQuery = _interopRequireDefault(require("../queries/designTabQuery.graphql"));
var _projectSettings = _interopRequireDefault(require("./projectSettings.graphql"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _union2 = _interopRequireDefault(require("lodash/union"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _admin = require("../selectors/admin.js");
var _nanoid = require("nanoid");
var _getColumnTree = require("../pages/Data/CustomQueryForm/getColumnTree.js");
var _handleActions;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var defaultQuerySettings = {
  assignmentId: 0,
  deploymentIds: 'all',
  surveyHandles: 'all',
  columns: {
    'pawn.pawnId': {
      id: 'pawn.pawnId',
      sort: 1,
      label: 'System ID',
      type: 'number'
    },
    'pawn.createdDate': {
      id: 'pawn.createdDate',
      sort: 2,
      label: 'Created Date',
      type: 'string'
    }
  },
  codedValues: true,
  missingValues: true,
  waveHandle: false,
  waveTimepoint: false,
  metrics: {
    types: ['qualitative', 'quantitative', 'additional_coding', 'formula'],
    list: []
  },
  filter: null,
  visualizationSettings: {}
};
var initialState = exports.initialState = {
  organizationList: [],
  projectList: [],
  currentProjectId: 0,
  currentAssignmentId: 0,
  currentDeploymentId: 0,
  selectedDeploymentIds: [],
  currentDeploymentIds: [],
  deploymentDropdownVisible: false,
  currentSurveyId: 0,
  currentSurveyHandle: '0',
  currentSurveyHandles: [],
  surveyDropdownVisible: false,
  expandedDesignAssignmentIds: [],
  expandedDeployAssignmentIds: [],
  showArchivedAssignments: false,
  showArchivedSurveys: [],
  currentSurveyListHandles: {},
  designFilter: '',
  deployFilter: '',
  devTags: [],
  queryList: [],
  queryTagFilter: [],
  currentQueryId: '0',
  currentQuerySettings: defaultQuerySettings,
  deploymentListLimit: 10000,
  vizData: {},
  visibleDeploymentIds: null
};

// Actions
var SET_ORGANIZATION_LIST = 'assignment/admin/SET_ORGANIZATION_LIST';
var SET_PROJECT_LIST = 'assignment/admin/SET_PROJECT_LIST';
var SET_PROJECT_FLOWS = 'assignment/admin/SET_PROJECT_FLOWS';
var SET_CURRENT_PROJECT_ID = 'assignment/admin/SET_CURRENT_PROJECT_ID';
var SET_CURRENT_ASSIGNMENT_ID = 'assignment/admin/SET_CURRENT_ASSIGNMENT_ID';
var SET_CURRENT_ASSIGNMENT_ID_ONLY = 'assignment/admin/SET_CURRENT_ASSIGNMENT_ID_ONLY';
var SET_CURRENT_DEPLOYMENT_ID = 'assignment/admin/SET_CURRENT_DEPLOYMENT_ID';
var SET_SELECTED_DEPLOYMENT_IDS = 'assignment/admin/SET_SELECTED_DEPLOYMENT_IDS';
var SET_CURRENT_DEPLOYMENT_IDS = 'assignment/admin/SET_CURRENT_DEPLOYMENT_IDS';
var SET_CURRENT_SURVEY_ID = 'assignment/admin/SET_CURRENT_SURVEY_ID';
var SET_CURRENT_SURVEY_HANDLE = 'assignment/admin/SET_CURRENT_SURVEY_HANDLE';
var SET_CURRENT_SURVEY_HANDLES = 'assignment/admin/SET_CURRENT_SURVEY_HANDLES';
var SET_EXPANDED_ALL_DESIGN_ASSIGNMENTS = 'assignment/admin/SET_EXPANDED_ALL_DESIGN_ASSIGNMENTS';
var TOGGLE_COLLAPSED_DESIGN_ASSIGNMENT = 'assignment/admin/TOGGLE_COLLAPSED_DESIGN_ASSIGNMENT';
var SET_EXPANDED_ALL_DEPLOY_ASSIGNMENTS = 'assignment/admin/SET_EXPANDED_ALL_DEPLOY_ASSIGNMENTS';
var TOGGLE_COLLAPSED_DEPLOY_ASSIGNMENT = 'assignment/admin/TOGGLE_COLLAPSED_DEPLOY_ASSIGNMENT';
var TOGGLE_ARCHIVED_ASSIGNMENTS = 'assignment/admin/TOGGLE_ARCHIVED_ASSIGNMENTS';
var TOGGLE_ARCHIVED_SURVEYS = 'assignment/admin/TOGGLE_ARCHIVED_SURVEYS';
var MOVE_SURVEY = 'assignment/admin/MOVE_SURVEY';
var SET_CURRENT_SURVEY_LIST_HANDLE = 'assignment/admin/SET_CURRENT_SURVEY_LIST_HANDLE';
var SET_WAVE_OPEN_STATUS = 'assignment/admin/SET_WAVE_OPEN_STATUS';
var CHANGE_DESIGN_FILTER = 'assignment/admin/CHANGE_DESIGN_FILTER';
var CHANGE_DEPLOY_FILTER = 'assignment/admin/CHANGE_DEPLOY_FILTER';
var SET_DEV_TAGS = 'assignment/admin/SET_DEV_TAGS';
var SET_QUERY_LIST = 'assignment/admin/SET_QUERY_LIST';
var ADD_NEW_QUERY = 'assignment/admin/ADD_NEW_QUERY';
var UPDATE_QUERY = 'assignment/admin/UPDATE_QUERY';
var DELETE_CURRENT_QUERY = 'assignment/admin/DELETE_CURRENT_QUERY';
var SET_CURRENT_QUERY_ID = 'assignment/admin/SET_CURRENT_QUERY_ID';
var SET_CURRENT_QUERY_SETTINGS = 'assignment/admin/SET_CURRENT_QUERY_SETTINGS';
var SET_VIZ_DATA = 'assignment/admin/SET_VIZ_DATA';
var SET_VISIBLE_DEPLOYMENT_IDS = 'assignment/admin/SET_VISIBLE_DEPLOYMENT_IDS';
var CLEAR_VISIBLE_DEPLOYMENT_IDS = 'assignment/admin/CLEAR_VISIBLE_DEPLOYMENT_IDS';
var SET_QUERY_TAG_FILTER = 'assignment/admin/SET_QUERY_TAG_FILTER';
var RESET_STATE = 'assignment/admin/RESET_STATE';

// Action Creators
var setOrganizationList = exports.setOrganizationList = (0, _reduxActions.createAction)(SET_ORGANIZATION_LIST);
var setProjectList = exports.setProjectList = (0, _reduxActions.createAction)(SET_PROJECT_LIST);
var setCurrentProjectId = exports.setCurrentProjectId = (0, _reduxActions.createAction)(SET_CURRENT_PROJECT_ID);
var setCurrentAssignmentId = exports.setCurrentAssignmentId = (0, _reduxActions.createAction)(SET_CURRENT_ASSIGNMENT_ID);
var setCurrentAssignmentIdOnly = exports.setCurrentAssignmentIdOnly = (0, _reduxActions.createAction)(SET_CURRENT_ASSIGNMENT_ID_ONLY);
var setCurrentDeploymentId = exports.setCurrentDeploymentId = (0, _reduxActions.createAction)(SET_CURRENT_DEPLOYMENT_ID);
var setSelectedDeploymentIds = exports.setSelectedDeploymentIds = (0, _reduxActions.createAction)(SET_SELECTED_DEPLOYMENT_IDS);
var setCurrentDeploymentIds = exports.setCurrentDeploymentIds = (0, _reduxActions.createAction)(SET_CURRENT_DEPLOYMENT_IDS);
var setCurrentSurveyId = exports.setCurrentSurveyId = (0, _reduxActions.createAction)(SET_CURRENT_SURVEY_ID);
var setCurrentSurveyHandle = exports.setCurrentSurveyHandle = (0, _reduxActions.createAction)(SET_CURRENT_SURVEY_HANDLE);
var setCurrentSurveyHandles = exports.setCurrentSurveyHandles = (0, _reduxActions.createAction)(SET_CURRENT_SURVEY_HANDLES);
var setProjectFlows = exports.setProjectFlows = (0, _reduxActions.createAction)(SET_PROJECT_FLOWS);
var setExpandedAllDesignAssignments = exports.setExpandedAllDesignAssignments = (0, _reduxActions.createAction)(SET_EXPANDED_ALL_DESIGN_ASSIGNMENTS);
var toggleCollapsedDesignAssignment = exports.toggleCollapsedDesignAssignment = (0, _reduxActions.createAction)(TOGGLE_COLLAPSED_DESIGN_ASSIGNMENT);
var setExpandedAllDeployAssignments = exports.setExpandedAllDeployAssignments = (0, _reduxActions.createAction)(SET_EXPANDED_ALL_DEPLOY_ASSIGNMENTS);
var toggleCollapsedDeployAssignment = exports.toggleCollapsedDeployAssignment = (0, _reduxActions.createAction)(TOGGLE_COLLAPSED_DEPLOY_ASSIGNMENT);
var toggleArchivedAssignments = exports.toggleArchivedAssignments = (0, _reduxActions.createAction)(TOGGLE_ARCHIVED_ASSIGNMENTS);
var toggleArchivedSurveys = exports.toggleArchivedSurveys = (0, _reduxActions.createAction)(TOGGLE_ARCHIVED_SURVEYS);
var moveSurvey = exports.moveSurvey = (0, _reduxActions.createAction)(MOVE_SURVEY);
var setCurrentSurveyListHandle = exports.setCurrentSurveyListHandle = (0, _reduxActions.createAction)(SET_CURRENT_SURVEY_LIST_HANDLE);
var setWaveOpenStatus = exports.setWaveOpenStatus = (0, _reduxActions.createAction)(SET_WAVE_OPEN_STATUS);
var changeDesignFilter = exports.changeDesignFilter = (0, _reduxActions.createAction)(CHANGE_DESIGN_FILTER);
var changeDeployFilter = exports.changeDeployFilter = (0, _reduxActions.createAction)(CHANGE_DEPLOY_FILTER);
var setDevTags = exports.setDevTags = (0, _reduxActions.createAction)(SET_DEV_TAGS);
var setQueryList = exports.setQueryList = (0, _reduxActions.createAction)(SET_QUERY_LIST);
var addNewQueryWithoutSave = exports.addNewQueryWithoutSave = (0, _reduxActions.createAction)(ADD_NEW_QUERY);
var updateQueryWithoutSave = exports.updateQueryWithoutSave = (0, _reduxActions.createAction)(UPDATE_QUERY);
var deleteCurrentQueryWithoutSave = exports.deleteCurrentQueryWithoutSave = (0, _reduxActions.createAction)(DELETE_CURRENT_QUERY);
var setCurrentQueryId = exports.setCurrentQueryId = (0, _reduxActions.createAction)(SET_CURRENT_QUERY_ID);
var setCurrentQuerySettings = exports.setCurrentQuerySettings = (0, _reduxActions.createAction)(SET_CURRENT_QUERY_SETTINGS);
var setVizData = exports.setVizData = (0, _reduxActions.createAction)(SET_VIZ_DATA);
var setVisibleDeploymentIds = exports.setVisibleDeploymentIds = (0, _reduxActions.createAction)(SET_VISIBLE_DEPLOYMENT_IDS);
var clearVisibleDeploymentIds = exports.clearVisibleDeploymentIds = (0, _reduxActions.createAction)(CLEAR_VISIBLE_DEPLOYMENT_IDS);
var setQueryTagFilter = exports.setQueryTagFilter = (0, _reduxActions.createAction)(SET_QUERY_TAG_FILTER);
var resetState = exports.resetState = (0, _reduxActions.createAction)(RESET_STATE);
var saveQueries = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(state) {
    var _result$data$groups$q;
    var deletedIds,
      currentProjectId,
      currentQueries,
      result,
      existingQueries,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          deletedIds = _args.length > 1 && _args[1] !== undefined ? _args[1] : [];
          currentProjectId = state.currentProjectId;
          currentQueries = (0, _admin.getCurrentProjectQueries)(state);
          _context.n = 1;
          return _cccisdApollo.client.query({
            query: _projectSettings["default"],
            variables: {
              groupId: currentProjectId
            },
            fetchPolicy: 'network-only'
          });
        case 1:
          result = _context.v;
          existingQueries = ((_result$data$groups$q = result.data.groups.questproject.group.settings) === null || _result$data$groups$q === void 0 ? void 0 : _result$data$groups$q.queryList) || [];
          _context.n = 2;
          return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.group.update', {
            group: currentProjectId
          }), {
            settings: {
              queryList: (0, _uniqBy2["default"])([].concat(_toConsumableArray(currentQueries), _toConsumableArray(existingQueries)).filter(function (item) {
                return !deletedIds.includes(item.id);
              }), 'id')
            }
          });
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function saveQueries(_x) {
    return _ref.apply(this, arguments);
  };
}();
var addNewQuery = exports.addNewQuery = function addNewQuery() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(addNewQueryWithoutSave.apply(void 0, args));
            _context2.n = 1;
            return saveQueries(getState().assignment.admin);
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var updateQuery = exports.updateQuery = function updateQuery() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            dispatch(updateQueryWithoutSave.apply(void 0, args));
            _context3.n = 1;
            return saveQueries(getState().assignment.admin);
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var deleteCurrentQuery = exports.deleteCurrentQuery = function deleteCurrentQuery() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var deletedQueryId;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            deletedQueryId = getState().assignment.admin.currentQueryId;
            dispatch(deleteCurrentQueryWithoutSave.apply(void 0, args));
            dispatch(setCurrentQueryId('0'));
            _context4.n = 1;
            return saveQueries(getState().assignment.admin, [deletedQueryId]);
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var loadProjectList = exports.loadProjectList = function loadProjectList() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    forceReload = _ref5.forceReload;
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var state, result, organizationHash, organizationList, projectList, _t;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            // Don't load projects twice
            state = getState().assignment.admin;
            if (!(state.projectList.length > 0 && !forceReload)) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            if (!(Fortress.user.acting.data_type === 'guest')) {
              _context5.n = 2;
              break;
            }
            window.location = Boilerplate.url('account/login');
            return _context5.a(2);
          case 2:
            result = null;
            _context5.p = 3;
            _context5.n = 4;
            return _cccisdApollo.client.query({
              query: _projectListQuery["default"],
              fetchPolicy: 'network-only'
            });
          case 4:
            result = _context5.v;
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t = _context5.v;
            return _context5.a(2);
          case 6:
            organizationHash = result.data.groups.questprojectList.reduce(function (obj, project) {
              var group = project.parentGroup.questorganization.group;
              if (!obj[group.groupId]) {
                obj[group.groupId] = _objectSpread(_objectSpread({}, (0, _pick2["default"])(group, ['groupId', 'label'])), {}, {
                  restrictionsLevel: project.parentGroup.questorganization.fields.level
                });
              }
              return obj;
            }, {});
            organizationList = Object.values(organizationHash).sort(function (a, b) {
              return a.label.localeCompare(b.label);
            });
            projectList = result.data.groups.questprojectList.map(function (project) {
              return _objectSpread(_objectSpread({}, project.group), {}, {
                fields: project.fields,
                organizationId: project.parentGroup.questorganization.group.groupId
              });
            });
            dispatch(setProjectList(projectList));
            dispatch(setOrganizationList(organizationList));
          case 7:
            return _context5.a(2);
        }
      }, _callee5, null, [[3, 5]]);
    }));
    return function (_x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var loadProject = exports.loadProject = function loadProject(groupId) {
  var deploymentIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch, getState) {
      var deploymentListLimit, result, isLimited, limitedAssignents, _t2;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            if (!(Fortress.user.acting.data_type === 'guest')) {
              _context6.n = 1;
              break;
            }
            window.location = Boilerplate.url('account/login');
            return _context6.a(2);
          case 1:
            deploymentListLimit = getState().assignment.admin.deploymentListLimit;
            result = null;
            _context6.p = 2;
            _context6.n = 3;
            return _cccisdApollo.client.query({
              query: _designTabQuery["default"],
              variables: {
                groupId: groupId,
                deploymentIds: deploymentIds,
                limit: deploymentListLimit
              },
              fetchPolicy: 'network-only'
            });
          case 3:
            result = _context6.v;
            _context6.n = 5;
            break;
          case 4:
            _context6.p = 4;
            _t2 = _context6.v;
            return _context6.a(2);
          case 5:
            isLimited = result.data.flows.assignmentList.some(function (assignment) {
              return assignment.deploymentList.length >= deploymentListLimit;
            });
            if (isLimited) {
              limitedAssignents = result.data.flows.assignmentList.filter(function (assignment) {
                return assignment.deploymentList.length >= deploymentListLimit;
              });
              (0, _cccisdNotification["default"])({
                type: 'warning',
                message: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("b", null, "Warning!")), "The following Quests have many data collection waves. Some data collection waves may not be shown.", /*#__PURE__*/_react["default"].createElement("ul", null, limitedAssignents.map(function (assignment) {
                  return /*#__PURE__*/_react["default"].createElement("li", {
                    key: assignment.assignmentId
                  }, assignment.label);
                }))),
                duration: 8000
              });
            }
            dispatch(setProjectFlows({
              groupId: groupId,
              flows: result.data.flows
            }));
            dispatch(setCurrentProjectId(groupId));
          case 6:
            return _context6.a(2);
        }
      }, _callee6, null, [[2, 4]]);
    }));
    return function (_x0, _x1) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var loadDevTags = exports.loadDevTags = function loadDevTags() {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(dispatch, getState) {
      var response;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            _context7.n = 1;
            return _cccisdAxios["default"].get(Boilerplate.route('poly.api.v1.tag.tagNames') + '?scope=developer');
          case 1:
            response = _context7.v;
            dispatch(setDevTags(response.data));
          case 2:
            return _context7.a(2);
        }
      }, _callee7);
    }));
    return function (_x10, _x11) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var reloadCurrentProject = exports.reloadCurrentProject = function reloadCurrentProject() {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(dispatch, getState) {
      var _getState$assignment$, currentProjectId, projectList, newCurrentProjectId, questTabPermissions, projectWithPermission;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            _getState$assignment$ = getState().assignment.admin, currentProjectId = _getState$assignment$.currentProjectId, projectList = _getState$assignment$.projectList;
            newCurrentProjectId = currentProjectId;
            if (!projectList.find(function (p) {
              return Number.parseInt(p.groupId, 10) === Number.parseInt(currentProjectId, 10);
            })) {
              questTabPermissions = ['quest.design', 'quest.deploy', 'quest.status', 'quest.code', 'quest.view_data', 'quest.permissions', 'quest.admin'];
              projectWithPermission = projectList.find(function (p) {
                return Fortress.hasAnyAccess(questTabPermissions, p.groupId);
              });
              newCurrentProjectId = !projectWithPermission ? 0 : Number.parseInt(projectWithPermission.groupId, 10);
            }
            _context8.n = 1;
            return dispatch(loadProject(newCurrentProjectId));
          case 1:
            return _context8.a(2);
        }
      }, _callee8);
    }));
    return function (_x12, _x13) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var createQuest = exports.createQuest = function createQuest(values) {
  return /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(dispatch, getState) {
      var currentProjectId, response, isSuccess;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            currentProjectId = getState().assignment.admin.currentProjectId;
            _context9.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.store'), {
              group: currentProjectId,
              label: values.title,
              description: values.subtitle,
              product: values.productId || null,
              settings: (0, _omit2["default"])(values, ['title', 'subtitle', 'productId'])
            });
          case 1:
            response = _context9.v;
            if (!response.data.errors) {
              _context9.n = 2;
              break;
            }
            throw response.data.errors;
          case 2:
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context9.n = 3;
              break;
            }
            _context9.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            return _context9.a(2, isSuccess);
        }
      }, _callee9);
    }));
    return function (_x14, _x15) {
      return _ref0.apply(this, arguments);
    };
  }();
};
var updateQuest = exports.updateQuest = function updateQuest(assignmentId, values) {
  return /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(dispatch, getState) {
      var updateData, response;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.n) {
          case 0:
            updateData = {
              assignmentId: assignmentId,
              label: values.title,
              description: values.subtitle,
              product: values.productId || null,
              settings: (0, _omit2["default"])(values, ['title', 'subtitle', 'handle', 'productId'])
            };
            if (values.handle) {
              updateData.handle = values.handle;
            }
            _context0.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.update'), updateData);
          case 1:
            response = _context0.v;
            if (!(response.data.status === 'success')) {
              _context0.n = 3;
              break;
            }
            _context0.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            _context0.n = 4;
            break;
          case 3:
            throw response.data.errors;
          case 4:
            return _context0.a(2);
        }
      }, _callee0);
    }));
    return function (_x16, _x17) {
      return _ref1.apply(this, arguments);
    };
  }();
};
var updateQuestSettings = exports.updateQuestSettings = function updateQuestSettings(assignmentId, settings) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            _context1.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route("api.assignment.update"), {
              assignmentId: assignmentId,
              settings: settings
            });
          case 1:
            response = _context1.v;
            if (!response.data.errors) {
              _context1.n = 2;
              break;
            }
            throw response.data.errors;
          case 2:
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context1.n = 3;
              break;
            }
            _context1.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            return _context1.a(2, isSuccess);
        }
      }, _callee1);
    }));
    return function (_x18, _x19) {
      return _ref10.apply(this, arguments);
    };
  }();
};
var archiveQuest = exports.archiveQuest = function archiveQuest(assignmentId) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.n) {
          case 0:
            _context10.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignment.archive', {
              assignmentId: assignmentId
            }));
          case 1:
            response = _context10.v;
            if (response.data.errors && response.data.errors.assignment) {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: response.data.errors.assignment[0]
              });
            }
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context10.n = 2;
              break;
            }
            _context10.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            return _context10.a(2, isSuccess);
        }
      }, _callee10);
    }));
    return function (_x20, _x21) {
      return _ref11.apply(this, arguments);
    };
  }();
};
var unarchiveQuest = exports.unarchiveQuest = function unarchiveQuest(assignmentId) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            _context11.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignment.unarchive', {
              assignmentId: assignmentId
            }));
          case 1:
            response = _context11.v;
            if (response.data.errors && response.data.errors.assignment) {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: response.data.errors.assignment[0]
              });
            }
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context11.n = 2;
              break;
            }
            _context11.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            return _context11.a(2, isSuccess);
        }
      }, _callee11);
    }));
    return function (_x22, _x23) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var deleteQuest = exports.deleteQuest = function deleteQuest(assignmentId) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.n) {
          case 0:
            _context12.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route("api.assignment.destroy", {
              assignmentId: assignmentId
            }));
          case 1:
            response = _context12.v;
            if (response.data.errors && response.data.errors.assignment) {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: response.data.errors.assignment[0]
              });
            }
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context12.n = 2;
              break;
            }
            _context12.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            return _context12.a(2, isSuccess);
        }
      }, _callee12);
    }));
    return function (_x24, _x25) {
      return _ref13.apply(this, arguments);
    };
  }();
};
var createSurvey = exports.createSurvey = function createSurvey(surveyListId, values) {
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.n) {
          case 0:
            _context13.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentSurvey.store'), {
              label: values.title,
              description: values.subtitle,
              assignmentSurveylistId: surveyListId,
              settings: (0, _omit2["default"])(values, ['title', 'subtitle'])
            });
          case 1:
            response = _context13.v;
            if (!response.data.errors) {
              _context13.n = 2;
              break;
            }
            throw response.data.errors;
          case 2:
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context13.n = 3;
              break;
            }
            _context13.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            return _context13.a(2, isSuccess);
        }
      }, _callee13);
    }));
    return function (_x26, _x27) {
      return _ref14.apply(this, arguments);
    };
  }();
};
var updateSurvey = exports.updateSurvey = function updateSurvey(surveyId, values) {
  return /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.n) {
          case 0:
            _context14.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentSurvey.update', {
              surveyId: surveyId
            }), {
              label: values.title,
              description: values.subtitle,
              settings: (0, _omit2["default"])(values, ['title', 'subtitle'])
            });
          case 1:
            response = _context14.v;
            if (!response.data.errors) {
              _context14.n = 2;
              break;
            }
            throw response.data.errors;
          case 2:
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context14.n = 3;
              break;
            }
            _context14.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            return _context14.a(2, isSuccess);
        }
      }, _callee14);
    }));
    return function (_x28, _x29) {
      return _ref15.apply(this, arguments);
    };
  }();
};
var updateSurveySettings = exports.updateSurveySettings = function updateSurveySettings(surveyId, settings) {
  return /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.n) {
          case 0:
            _context15.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentSurvey.update", {
              surveyId: surveyId
            }), {
              settings: settings
            });
          case 1:
            response = _context15.v;
            if (!response.data.errors) {
              _context15.n = 2;
              break;
            }
            throw response.data.errors;
          case 2:
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context15.n = 3;
              break;
            }
            _context15.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            return _context15.a(2, isSuccess);
        }
      }, _callee15);
    }));
    return function (_x30, _x31) {
      return _ref16.apply(this, arguments);
    };
  }();
};
var archiveSurvey = exports.archiveSurvey = function archiveSurvey(surveyId) {
  return /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(dispatch, getState) {
      var response;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.n) {
          case 0:
            _context16.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentSurvey.archive', {
              surveyId: surveyId
            }));
          case 1:
            response = _context16.v;
            if (!(response.data.status === 'success')) {
              _context16.n = 3;
              break;
            }
            _context16.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            _context16.n = 4;
            break;
          case 3:
            throw response.data.errors;
          case 4:
            return _context16.a(2);
        }
      }, _callee16);
    }));
    return function (_x32, _x33) {
      return _ref17.apply(this, arguments);
    };
  }();
};
var unarchiveSurvey = exports.unarchiveSurvey = function unarchiveSurvey(surveyId) {
  return /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context17) {
        while (1) switch (_context17.n) {
          case 0:
            _context17.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentSurvey.unarchive", {
              surveyId: surveyId
            }));
          case 1:
            response = _context17.v;
            if (response.data.errors && response.data.errors.survey) {
              (0, _cccisdNotification["default"])({
                type: 'danger',
                message: response.data.errors.survey[0]
              });
            }
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context17.n = 2;
              break;
            }
            _context17.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            return _context17.a(2, isSuccess);
        }
      }, _callee17);
    }));
    return function (_x34, _x35) {
      return _ref18.apply(this, arguments);
    };
  }();
};
var deleteSurvey = exports.deleteSurvey = function deleteSurvey(surveyId) {
  return /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(dispatch, getState) {
      var response;
      return _regenerator().w(function (_context18) {
        while (1) switch (_context18.n) {
          case 0:
            _context18.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentSurvey.destroy", {
              surveyId: surveyId
            }));
          case 1:
            response = _context18.v;
            if (!(response.data.status === 'success')) {
              _context18.n = 3;
              break;
            }
            _context18.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            _context18.n = 4;
            break;
          case 3:
            throw response.data.errors;
          case 4:
            return _context18.a(2);
        }
      }, _callee18);
    }));
    return function (_x36, _x37) {
      return _ref19.apply(this, arguments);
    };
  }();
};
var deleteFlow = exports.deleteFlow = function deleteFlow(flowId) {
  return /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(dispatch, getState) {
      var response;
      return _regenerator().w(function (_context19) {
        while (1) switch (_context19.n) {
          case 0:
            _context19.n = 1;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('flow.destroy', {
              flow: flowId
            }));
          case 1:
            response = _context19.v;
            if (!(response.data.status === 'success')) {
              _context19.n = 3;
              break;
            }
            _context19.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            _context19.n = 4;
            break;
          case 3:
            throw response.data.errors;
          case 4:
            return _context19.a(2);
        }
      }, _callee19);
    }));
    return function (_x38, _x39) {
      return _ref20.apply(this, arguments);
    };
  }();
};
var moveSurveyAndSave = exports.moveSurveyAndSave = function moveSurveyAndSave(_ref21) {
  var assignmentId = _ref21.assignmentId,
    sourceIndex = _ref21.sourceIndex,
    destinationIndex = _ref21.destinationIndex;
  return /*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(dispatch, getState) {
      var getSurveylistList, prevPositions, updatedSurveys, _iterator, _step, survey, _t3;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.p = _context20.n) {
          case 0:
            getSurveylistList = function getSurveylistList() {
              return (0, _admin.getCurrentProject)(getState().assignment.admin).flows.assignmentList.find(function (item) {
                return item.assignmentId === assignmentId;
              }).currentSurveylistList.surveyList;
            };
            prevPositions = getSurveylistList().reduce(function (res, item) {
              return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, item.surveyId, item.position));
            }, {});
            dispatch(moveSurvey({
              assignmentId: assignmentId,
              sourceIndex: sourceIndex,
              destinationIndex: destinationIndex
            }));
            updatedSurveys = getSurveylistList().filter(function (item) {
              return prevPositions[item.surveyId] !== item.position;
            }); // TODO: send one request instead of many. For now, do one-at-a-time to
            // ensure we don't 500 with deadlocks
            _iterator = _createForOfIteratorHelper(updatedSurveys);
            _context20.p = 1;
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context20.n = 4;
              break;
            }
            survey = _step.value;
            _context20.n = 3;
            return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentSurvey.update", {
              surveyId: survey.surveyId
            }), {
              ordinalPosition: survey.position
            });
          case 3:
            _context20.n = 2;
            break;
          case 4:
            _context20.n = 6;
            break;
          case 5:
            _context20.p = 5;
            _t3 = _context20.v;
            _iterator.e(_t3);
          case 6:
            _context20.p = 6;
            _iterator.f();
            return _context20.f(6);
          case 7:
            return _context20.a(2, true);
        }
      }, _callee20, null, [[1, 5, 6, 7]]);
    }));
    return function (_x40, _x41) {
      return _ref22.apply(this, arguments);
    };
  }();
};
var reorderAssignmentsAndSave = exports.reorderAssignmentsAndSave = function reorderAssignmentsAndSave(updatedAssignments) {
  return /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(dispatch, getState) {
      return _regenerator().w(function (_context21) {
        while (1) switch (_context21.n) {
          case 0:
            if (!(updatedAssignments.length === 0)) {
              _context21.n = 1;
              break;
            }
            return _context21.a(2);
          case 1:
            _context21.n = 2;
            return _cccisdAxios["default"].put(Boilerplate.route("api.assignment.reorder"), {
              assignments: updatedAssignments.map(function (item) {
                return {
                  id: item.assignmentId,
                  ordinalPosition: item.ordinalPosition
                };
              })
            });
          case 2:
            _context21.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            return _context21.a(2);
        }
      }, _callee21);
    }));
    return function (_x42, _x43) {
      return _ref23.apply(this, arguments);
    };
  }();
};
var reorderDeploymentsAndSave = exports.reorderDeploymentsAndSave = function reorderDeploymentsAndSave(updatedDeployments) {
  return /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(dispatch, getState) {
      return _regenerator().w(function (_context22) {
        while (1) switch (_context22.n) {
          case 0:
            if (!(updatedDeployments.length === 0)) {
              _context22.n = 1;
              break;
            }
            return _context22.a(2);
          case 1:
            _context22.n = 2;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.reorder'), {
              deployments: updatedDeployments.map(function (item) {
                return {
                  id: item.deploymentId,
                  ordinalPosition: item.ordinalPosition
                };
              })
            });
          case 2:
            _context22.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            return _context22.a(2);
        }
      }, _callee22);
    }));
    return function (_x44, _x45) {
      return _ref24.apply(this, arguments);
    };
  }();
};
var deleteMessage = exports.deleteMessage = function deleteMessage(deploymentId, deploymentMessageId) {
  return /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context23) {
        while (1) switch (_context23.n) {
          case 0:
            _context23.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentDeploymentMessage.destroy", {
              deploymentId: deploymentId,
              deploymentMessageId: deploymentMessageId
            }));
          case 1:
            response = _context23.v;
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context23.n = 2;
              break;
            }
            _context23.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            return _context23.a(2, isSuccess);
        }
      }, _callee23);
    }));
    return function (_x46, _x47) {
      return _ref25.apply(this, arguments);
    };
  }();
};
var unscheduleMessage = exports.unscheduleMessage = function unscheduleMessage(deploymentId, deploymentMessageId) {
  return /*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context24) {
        while (1) switch (_context24.n) {
          case 0:
            _context24.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route("api.assignmentDeploymentMessage.destroy", {
              deploymentId: deploymentId,
              deploymentMessageId: deploymentMessageId
            }));
          case 1:
            response = _context24.v;
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context24.n = 2;
              break;
            }
            _context24.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            return _context24.a(2, isSuccess);
        }
      }, _callee24);
    }));
    return function (_x48, _x49) {
      return _ref26.apply(this, arguments);
    };
  }();
};
var createFlow = exports.createFlow = function createFlow(data) {
  return /*#__PURE__*/function () {
    var _ref27 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(dispatch, getState) {
      var response, result, isSuccess;
      return _regenerator().w(function (_context25) {
        while (1) switch (_context25.n) {
          case 0:
            _context25.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('flow.store'), data);
          case 1:
            response = _context25.v;
            // Repsonse format is Task Master if it's copying from template or existing survey
            result = response.data.result || response.data;
            if (!result.errors) {
              _context25.n = 2;
              break;
            }
            throw result.errors;
          case 2:
            isSuccess = result.status === 'success';
            if (!isSuccess) {
              _context25.n = 3;
              break;
            }
            _context25.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            return _context25.a(2, isSuccess);
        }
      }, _callee25);
    }));
    return function (_x50, _x51) {
      return _ref27.apply(this, arguments);
    };
  }();
};
var createWave = exports.createWave = function createWave(assignmentId, values) {
  return /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context26) {
        while (1) switch (_context26.n) {
          case 0:
            _context26.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentDeployment.store'), _objectSpread(_objectSpread({}, values), {}, {
              assignmentId: assignmentId
            }));
          case 1:
            response = _context26.v;
            if (!response.data.errors) {
              _context26.n = 2;
              break;
            }
            throw response.data.errors;
          case 2:
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context26.n = 4;
              break;
            }
            _context26.n = 3;
            return dispatch(reloadCurrentProject());
          case 3:
            _context26.n = 4;
            return dispatch(setCurrentDeploymentId(response.data.data.id));
          case 4:
            return _context26.a(2, isSuccess);
        }
      }, _callee26);
    }));
    return function (_x52, _x53) {
      return _ref28.apply(this, arguments);
    };
  }();
};
var updateWave = exports.updateWave = function updateWave(deploymentId, values) {
  return /*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(dispatch, getState) {
      var response, isSuccess;
      return _regenerator().w(function (_context27) {
        while (1) switch (_context27.n) {
          case 0:
            _context27.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.update', {
              deploymentId: deploymentId
            }), values);
          case 1:
            response = _context27.v;
            isSuccess = response.data.status === 'success';
            if (!isSuccess) {
              _context27.n = 3;
              break;
            }
            _context27.n = 2;
            return dispatch(reloadCurrentProject());
          case 2:
            _context27.n = 3;
            return dispatch(setCurrentDeploymentId(deploymentId));
          case 3:
            return _context27.a(2, response);
        }
      }, _callee27);
    }));
    return function (_x54, _x55) {
      return _ref29.apply(this, arguments);
    };
  }();
};
var removeWave = exports.removeWave = function removeWave(deploymentId) {
  var dryRun = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return /*#__PURE__*/function () {
    var _ref30 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(dispatch, getState) {
      var response;
      return _regenerator().w(function (_context28) {
        while (1) switch (_context28.n) {
          case 0:
            _context28.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.destroy', {
              deploymentId: deploymentId
            }), {
              dryRun: dryRun
            });
          case 1:
            response = _context28.v;
            if (!dryRun) {
              _context28.n = 2;
              break;
            }
            return _context28.a(2, response);
          case 2:
            if (!(response.data.status !== 'success')) {
              _context28.n = 3;
              break;
            }
            return _context28.a(2, response);
          case 3:
            _context28.n = 4;
            return dispatch(reloadCurrentProject());
          case 4:
            return _context28.a(2);
        }
      }, _callee28);
    }));
    return function (_x56, _x57) {
      return _ref30.apply(this, arguments);
    };
  }();
};
var setWaveOpenStatusAndSave = exports.setWaveOpenStatusAndSave = function setWaveOpenStatusAndSave(_ref31) {
  var deploymentId = _ref31.deploymentId,
    isOpen = _ref31.isOpen;
  return /*#__PURE__*/function () {
    var _ref32 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(dispatch, getState) {
      return _regenerator().w(function (_context29) {
        while (1) switch (_context29.n) {
          case 0:
            dispatch(setWaveOpenStatus({
              deploymentId: deploymentId,
              isOpen: isOpen
            }));
            _context29.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignmentDeployment.update', {
              deploymentId: deploymentId
            }), {
              isOpen: isOpen
            });
          case 1:
            return _context29.a(2);
        }
      }, _callee29);
    }));
    return function (_x58, _x59) {
      return _ref32.apply(this, arguments);
    };
  }();
};

// reducer
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_ORGANIZATION_LIST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    organizationList: action.payload
  });
}), SET_PROJECT_LIST, function (state, action) {
  var projectList = action.payload;
  var queryList = [];
  var _iterator2 = _createForOfIteratorHelper(projectList),
    _step2;
  try {
    var _loop = function _loop() {
      var _project$settings;
      var project = _step2.value;
      var projectQueries = ((_project$settings = project.settings) === null || _project$settings === void 0 ? void 0 : _project$settings.queryList) || [];
      queryList.push.apply(queryList, _toConsumableArray(projectQueries.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          projectId: project.groupId
        });
      })));
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    projectList: projectList,
    queryList: queryList
  });
}), SET_CURRENT_PROJECT_ID, function (state, action) {
  var nextState = _objectSpread(_objectSpread({}, state), {}, {
    currentQueryId: '0',
    currentProjectId: action.payload,
    currentQuerySettings: _objectSpread({}, defaultQuerySettings)
  });
  var currentAssignmentId = state.currentAssignmentId,
    currDepId = state.currentDeploymentId,
    visibleDeploymentIds = state.visibleDeploymentIds;
  var activeAssignmentsIds = (0, _admin.getCurrentProjectActiveAssignments)(nextState).filter(function (item) {
    return !visibleDeploymentIds || item.deploymentList.length > 0;
  }).map(function (item) {
    return item.assignmentId;
  });
  nextState.currentQuerySettings.assignmentId = currentAssignmentId;
  nextState.currentQuerySettings.deploymentIds = 'all';
  nextState.currentQuerySettings.surveyHandles = 'all';
  if (!activeAssignmentsIds.includes(currentAssignmentId)) {
    nextState.currentAssignmentId = activeAssignmentsIds[0] || 0;
    nextState.currentQuerySettings.assignmentId = activeAssignmentsIds[0] || 0;
  }
  var assignmentDeployments = (0, _admin.getCurrentAssignmentDeployments)(nextState).filter(function (item) {
    return !item.archived;
  });
  var assignmentDeploymentsIds = assignmentDeployments.map(function (item) {
    return item.deploymentId;
  });
  var currentDeploymentId = !assignmentDeploymentsIds.some(function (id) {
    return id === currDepId;
  }) ? assignmentDeploymentsIds[0] || 0 : currDepId;
  nextState.currentDeploymentId = currentDeploymentId;
  nextState.currentDeploymentIds = currentDeploymentId ? [currentDeploymentId] : [];
  nextState.selectedDeploymentIds = currentDeploymentId ? [currentDeploymentId] : [];
  nextState.currentSurveyHandles = [];

  // get default columns
  {
    var deploymentList = (0, _admin.getCurrentQueryAssignmentActiveDeployments)(nextState);
    var roleHandles = (0, _uniq2["default"])(deploymentList.map(function (item) {
      return item.roleHandle;
    }));
    var columns = {};
    var _iterator3 = _createForOfIteratorHelper(roleHandles),
      _step3;
    try {
      var _loop2 = function _loop2() {
        var roleHandle = _step3.value;
        var levelInfo = window.cccisd.appDefs.pawn.roles.find(function (item) {
          return item.handle === roleHandle;
        });
        if (!levelInfo) {
          return 1; // continue
        }
        var columnTree = (0, _getColumnTree.getFlatColumnTree)('roles', levelInfo.handle);
        var importantFields = Array.isArray(levelInfo.importantFields) ? levelInfo.importantFields : [];
        importantFields.filter(function (field) {
          return field.path in columnTree;
        }).forEach(function (field) {
          columns[field.path] = columnTree[field.path];
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        if (_loop2()) continue;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    nextState.currentQuerySettings.columns = columns;
  }
  return nextState;
}), SET_CURRENT_ASSIGNMENT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentAssignmentId: parseInt(action.payload, 10),
    currentDeploymentId: initialState.currentDeploymentId,
    currentDeploymentIds: [],
    selectedDeploymentIds: [],
    currentSurveyHandles: []
  });
}), SET_CURRENT_ASSIGNMENT_ID_ONLY, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentAssignmentId: parseInt(action.payload, 10)
  });
}), SET_CURRENT_DEPLOYMENT_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentDeploymentId: parseInt(action.payload, 10),
    currentDeploymentIds: action.payload !== 0 ? [parseInt(action.payload, 10)] : [],
    selectedDeploymentIds: action.payload !== 0 ? [parseInt(action.payload, 10)] : []
  });
}), SET_SELECTED_DEPLOYMENT_IDS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedDeploymentIds: action.payload
  });
}), SET_CURRENT_DEPLOYMENT_IDS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentDeploymentId: action.payload.length ? parseInt(action.payload[0], 10) : initialState.currentDeploymentId,
    currentDeploymentIds: action.payload
  });
}), SET_CURRENT_SURVEY_ID, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentSurveyId: parseInt(action.payload, 10)
  });
}), SET_CURRENT_SURVEY_HANDLE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentSurveyHandle: action.payload
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_CURRENT_SURVEY_HANDLES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentSurveyHandles: action.payload
  });
}), SET_PROJECT_FLOWS, function (state, action) {
  var _action$payload, _action$payload$flows;
  // populate buildLanguages in the payload
  var payload = (_action$payload = action.payload) !== null && _action$payload !== void 0 && (_action$payload$flows = _action$payload.flows) !== null && _action$payload$flows !== void 0 && _action$payload$flows.assignmentList ? _objectSpread(_objectSpread({}, action.payload), {}, {
    flows: _objectSpread(_objectSpread({}, action.payload.flows), {}, {
      assignmentList: action.payload.flows.assignmentList.map(function (assignment) {
        return _objectSpread(_objectSpread({}, assignment), {}, {
          settings: _objectSpread(_objectSpread({}, assignment.settings), {}, {
            buildLanguages: assignment.settings.buildLanguages || assignment.settings.languages
          })
        });
      })
    })
  }) : action.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    projectList: state.projectList.map(function (project) {
      return project.groupId === payload.groupId ? _objectSpread(_objectSpread({}, project), {}, {
        flows: payload.flows
      }) : project;
    })
  });
}), SET_EXPANDED_ALL_DESIGN_ASSIGNMENTS, function (state, action) {
  var expand = action.payload;
  var currentProjectAssignmentIds = (0, _admin.getCurrentProjectAssignments)(state).map(function (obj) {
    return obj.assignmentId;
  });
  var expandedDesignAssignmentIds = expand ? (0, _union2["default"])(state.expandedDesignAssignmentIds, currentProjectAssignmentIds) : (0, _difference2["default"])(state.expandedDesignAssignmentIds, currentProjectAssignmentIds);
  return _objectSpread(_objectSpread({}, state), {}, {
    expandedDesignAssignmentIds: expandedDesignAssignmentIds
  });
}), TOGGLE_COLLAPSED_DESIGN_ASSIGNMENT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    expandedDesignAssignmentIds: (0, _xor2["default"])(state.expandedDesignAssignmentIds, [action.payload])
  });
}), SET_EXPANDED_ALL_DEPLOY_ASSIGNMENTS, function (state, action) {
  var expand = action.payload;
  var currentProjectAssignmentIds = (0, _admin.getCurrentProjectAssignments)(state).map(function (obj) {
    return obj.assignmentId;
  });
  var expandedDeployAssignmentIds = expand ? (0, _union2["default"])(state.expandedDeployAssignmentIds, currentProjectAssignmentIds) : (0, _difference2["default"])(state.expandedDeployAssignmentIds, currentProjectAssignmentIds);
  return _objectSpread(_objectSpread({}, state), {}, {
    expandedDeployAssignmentIds: expandedDeployAssignmentIds
  });
}), TOGGLE_COLLAPSED_DEPLOY_ASSIGNMENT, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    expandedDeployAssignmentIds: (0, _xor2["default"])(state.expandedDeployAssignmentIds, [action.payload])
  });
}), TOGGLE_ARCHIVED_ASSIGNMENTS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showArchivedAssignments: !state.showArchivedAssignments
  });
}), TOGGLE_ARCHIVED_SURVEYS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showArchivedSurveys: (0, _xor2["default"])(state.showArchivedSurveys, [action.payload])
  });
}), SET_CURRENT_SURVEY_LIST_HANDLE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentSurveyListHandles: _objectSpread(_objectSpread({}, state.currentSurveyListHandles), {}, _defineProperty({}, action.payload.assignmentId, action.payload.handle))
  });
}), MOVE_SURVEY, function (state, action) {
  var _action$payload2 = action.payload,
    assignmentId = _action$payload2.assignmentId,
    sourceIndex = _action$payload2.sourceIndex,
    destinationIndex = _action$payload2.destinationIndex;
  var currentProjectId = state.currentProjectId,
    currentSurveyListHandles = state.currentSurveyListHandles;
  try {
    var sortByPosition = function sortByPosition(a, b) {
      return a.position - b.position;
    };
    var projectList = (0, _cloneDeep2["default"])(state.projectList);
    var currentProject = projectList.find(function (item) {
      return item.groupId === currentProjectId;
    });
    var currentAssignment = currentProject.flows.assignmentList.find(function (item) {
      return item.assignmentId === assignmentId;
    });
    var currentSurveylistList = currentSurveyListHandles[assignmentId] ? currentAssignment.surveylistList.find(function (item) {
      return item.surveylistHandle === currentSurveyListHandles[assignmentId];
    }) : currentAssignment.surveylistList[0];
    var surveyList = currentSurveylistList.surveyList.sort(sortByPosition);
    var activeSurveyList = surveyList.filter(function (item) {
      return !item.archived;
    });
    var sourcePosition = activeSurveyList[sourceIndex].position;
    var destinationPosition = activeSurveyList[destinationIndex].position;
    currentSurveylistList.surveyList = surveyList.map(function (item) {
      var position = item.position;
      if (item.position === sourcePosition) {
        position = destinationPosition;
      } else if (item.position > sourcePosition && item.position <= destinationPosition) {
        position = item.position - 1;
      } else if (item.position < sourcePosition && item.position >= destinationPosition) {
        position = item.position + 1;
      }
      return _objectSpread(_objectSpread({}, item), {}, {
        position: position
      });
    }).sort(sortByPosition);
    return _objectSpread(_objectSpread({}, state), {}, {
      projectList: projectList
    });
  } catch (e) {
    return state;
  }
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_WAVE_OPEN_STATUS, function (state, action) {
  var _action$payload3 = action.payload,
    deploymentId = _action$payload3.deploymentId,
    isOpen = _action$payload3.isOpen;
  var currentProjectId = state.currentProjectId;
  try {
    var projectList = (0, _cloneDeep2["default"])(state.projectList);
    var currentProject = projectList.find(function (item) {
      return item.groupId === currentProjectId;
    });
    var deployments = currentProject.flows.assignmentList.reduce(function (res, assignment) {
      return [].concat(_toConsumableArray(res), _toConsumableArray(assignment.deploymentList));
    }, []);
    var currentDeployment = deployments.find(function (item) {
      return item.deploymentId === deploymentId;
    });
    currentDeployment.isOpen = isOpen;
    return _objectSpread(_objectSpread({}, state), {}, {
      projectList: projectList
    });
  } catch (e) {
    return state;
  }
}), CHANGE_DESIGN_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    designFilter: action.payload
  });
}), CHANGE_DEPLOY_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    deployFilter: action.payload
  });
}), SET_DEV_TAGS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    devTags: action.payload
  });
}), SET_QUERY_LIST, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    queryList: action.payload
  });
}), ADD_NEW_QUERY, function (state, action) {
  var newId = (0, _nanoid.nanoid)();
  var projectId = state.currentProjectId;
  if (!projectId) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    currentQuerySettings: _objectSpread(_objectSpread({}, state.currentQuerySettings), {}, {
      visualizationSettings: action.payload.settings.visualizationSettings
    }),
    queryList: [].concat(_toConsumableArray(state.queryList), [_objectSpread(_objectSpread({}, action.payload), {}, {
      id: newId,
      projectId: projectId
    })]),
    currentQueryId: newId
  });
}), UPDATE_QUERY, function (state, action) {
  var _action$payload4, _action$payload4$sett;
  var newState = _objectSpread(_objectSpread({}, state), {}, {
    queryList: state.queryList.map(function (query) {
      if (query.id !== action.payload.id) {
        return query;
      }
      return _objectSpread(_objectSpread({}, query), action.payload);
    })
  });
  if (state.currentQuerySettings && (_action$payload4 = action.payload) !== null && _action$payload4 !== void 0 && (_action$payload4$sett = _action$payload4.settings) !== null && _action$payload4$sett !== void 0 && _action$payload4$sett.visualizationSettings) {
    newState.currentQuerySettings = _objectSpread(_objectSpread({}, state.currentQuerySettings), {}, {
      visualizationSettings: action.payload.settings.visualizationSettings
    });
  }
  return newState;
}), DELETE_CURRENT_QUERY, function (state, action) {
  if (!state.currentQueryId || state.currentQueryId === '0') {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    queryList: state.queryList.filter(function (query) {
      return query.id !== state.currentQueryId;
    })
  });
}), SET_CURRENT_QUERY_ID, function (state, action) {
  var nextQueryId = action.payload;
  if (nextQueryId === state.currentQueryId) {
    return state;
  }
  var currentProjectQueries = (0, _admin.getCurrentProjectQueries)(state);
  var nextState = _objectSpread(_objectSpread({}, state), {}, {
    currentQueryId: nextQueryId
  });
  if (nextQueryId === 'COMBINED_QUERY') {
    var foundQuery = currentProjectQueries.find(function (query) {
      return query.id === nextQueryId;
    });
    if (!foundQuery) {
      return state;
    }
    nextState.currentQuerySettings = foundQuery.settings;
  } else if (nextQueryId !== '0') {
    var _foundQuery = state.queryList.find(function (query) {
      return query.id === nextQueryId;
    });
    if (!_foundQuery) {
      // something wrong
      return state;
    }
    nextState.currentQuerySettings = _foundQuery.settings;
  } else {
    var visibleDeploymentIds = state.visibleDeploymentIds;

    // revert everything to default
    nextState.currentQuerySettings = _objectSpread({}, defaultQuerySettings);
    var activeAssignmentsIds = (0, _admin.getCurrentProjectActiveAssignments)(nextState).filter(function (item) {
      return !visibleDeploymentIds || item.deploymentList.length > 0;
    }).map(function (item) {
      return item.assignmentId;
    });
    if (activeAssignmentsIds.length === 0) {
      return nextState;
    }
    nextState.currentQuerySettings.assignmentId = activeAssignmentsIds[0];

    // get default columns
    {
      var deploymentList = (0, _admin.getCurrentQueryAssignmentActiveDeployments)(nextState);
      var roleHandles = (0, _uniq2["default"])(deploymentList.map(function (item) {
        return item.roleHandle;
      }));
      var columns = {};
      var _iterator4 = _createForOfIteratorHelper(roleHandles),
        _step4;
      try {
        var _loop3 = function _loop3() {
          var roleHandle = _step4.value;
          var levelInfo = window.cccisd.appDefs.pawn.roles.find(function (item) {
            return item.handle === roleHandle;
          });
          if (!levelInfo) {
            return 1; // continue
          }
          var columnTree = (0, _getColumnTree.getFlatColumnTree)('roles', levelInfo.handle);
          var importantFields = Array.isArray(levelInfo.importantFields) ? levelInfo.importantFields : [];
          importantFields.filter(function (field) {
            return field.path in columnTree;
          }).forEach(function (field) {
            columns[field.path] = columnTree[field.path];
          });
        };
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          if (_loop3()) continue;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      nextState.currentQuerySettings.columns = columns;
    }
  }
  return nextState;
}), SET_CURRENT_QUERY_SETTINGS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currentQuerySettings: action.payload || defaultQuerySettings
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_VIZ_DATA, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    vizData: _objectSpread(_objectSpread({}, state.vizData), action.payload)
  });
}), SET_VISIBLE_DEPLOYMENT_IDS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    visibleDeploymentIds: action.payload
  });
}), CLEAR_VISIBLE_DEPLOYMENT_IDS, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    visibleDeploymentIds: null
  });
}), SET_QUERY_TAG_FILTER, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    queryTagFilter: action.payload
  });
}), RESET_STATE, function (state, action) {
  return initialState;
})), initialState);